import React, { Fragment } from 'react';
import WebhookSection from './webhooks/WebhookSection';
import ApiKeySection from './api-keys/ApiKeySection';

const IntegrationsPageView = () => {
  return (
    <Fragment>
      <nav className="navbar navbar-expand navbar-light bg-light">
        <div className="navbar-brand">Integraties</div>
      </nav>
      <div className="container mt-4">
        <WebhookSection />
        <ApiKeySection />
      </div>
    </Fragment>
  );
};

export default IntegrationsPageView;
